import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

// attach admin token if present (sessionStorage — cleared on tab close, not persisted like localStorage)
client.interceptors.request.use((config) => {
  const token = sessionStorage.getItem('tag_admin_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Public
export const submitContact = (data) => client.post('/contact', data).then((r) => r.data);
export const submitQuiz = (data) => client.post('/quiz-results', data).then((r) => r.data);
export const getTestimonials = () => client.get('/testimonials').then((r) => r.data);
export const getLounge = () => client.get('/lounge').then((r) => r.data);
export const getLoungePost = (slug) => client.get(`/lounge/${slug}`).then((r) => r.data);

// Admin auth
export const adminLogin = (password) => client.post('/admin/login', { password }).then((r) => r.data);
export const adminVerify = () => client.get('/admin/verify').then((r) => r.data);

// Admin — inquiries
export const getInquiries = () => client.get('/contact').then((r) => r.data);
export const deleteInquiry = (id) => client.delete(`/contact/${id}`).then((r) => r.data);
export const getQuizResults = () => client.get('/quiz-results').then((r) => r.data);
export const setQuizBooked = (id, booked) => client.patch(`/quiz-results/${id}/booked`, { booked }).then((r) => r.data);
export const deleteQuizResult = (id) => client.delete(`/quiz-results/${id}`).then((r) => r.data);

// Admin — testimonials
export const getAllTestimonials = () => client.get('/testimonials/all').then((r) => r.data);
export const createTestimonial = (data) => client.post('/testimonials', data).then((r) => r.data);
export const updateTestimonial = (id, data) => client.put(`/testimonials/${id}`, data).then((r) => r.data);
export const deleteTestimonial = (id) => client.delete(`/testimonials/${id}`).then((r) => r.data);

// Admin — lounge
export const getAllLounge = () => client.get('/lounge/admin/all').then((r) => r.data);
export const createLounge = (data) => client.post('/lounge', data).then((r) => r.data);
export const updateLounge = (id, data) => client.put(`/lounge/${id}`, data).then((r) => r.data);
export const deleteLounge = (id) => client.delete(`/lounge/${id}`).then((r) => r.data);

export default client;
